<template>
	<div class="pd20">
		<!-- <div class="">
			<div class="form-search-box ">
				<a-form layout="inline">
					<a-form-item label="商品名称">
						<a-input v-model="search.name" placeholder="请输入商品名称"></a-input>
					</a-form-item>
		
					<a-form-item label="销量">
						<a-input v-model="search.bg_take_count" style="width: 150px"></a-input>
						-
						<a-input v-model="search.end_take_count" style="width: 150px"></a-input>
					</a-form-item>
					
					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>
		</div> -->
		
		<div class="">
			<div class="bg-w " style="min-height: 600px;">
				<div class="flex alcenter">
					<div class="">
						<a-radio-group v-model="search.status" button-style="solid" @change="changeStatus">
							<a-radio-button :value="1">
							  待成团
							</a-radio-button>
							<a-radio-button :value="2">
							  已成团
							</a-radio-button>
							<a-radio-button :value="-1">
							  拼团失败
							</a-radio-button>
						</a-radio-group>
					</div>
				</div>
				
				
				
				
				<div class="mt30">
					<div class="wxb-table-gray">
						<a-table rowKey="pin_tuan_group_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
						 :loading="loading">
							
							<div class="flex center " slot="goods_id" slot-scope="record">
								{{record.pin_tuan_goods.pin_tuan_goods_id}}
							</div>
						 
							<div class="flex center " slot="pin_tuan_goods" slot-scope="pin_tuan_goods,record">
								<div class="goods-index-cover-img">
									<img v-if="pin_tuan_goods.goods.cover_img != null" :src="pin_tuan_goods.goods.cover_img"/>
									<span class="tag" v-if="pin_tuan_goods.is_tui==1">首推</span>
								</div>
								<div class="ml10" style="text-align: left;">
									<div class="ft14 ftw500 cl-info text-over4" >
										{{pin_tuan_goods.goods.name}}
									</div>
									<div class="mt4 ft12 ftw500 cl-theme">拼团价格：¥{{pin_tuan_goods.pin_tuan_price}}</div>
									<div class=" flex alcenter ft12 ftw400 cl-notice">
										<div>门市原价：</div>
										<div style="text-decoration: line-through;">¥{{pin_tuan_goods.goods.original_price}}</div>
									</div>
								</div>
							</div>
							
							<div class="flex alcenter center" slot="group_size" slot-scope="group_size,record">
								<div class="pin-tuan-goods-num-box">{{group_size}}人团</div>
							</div>
							
							<div class="flex alcenter center" slot="chief" slot-scope="chief,record">
								{{chief.nick_name}} | {{chief.mobile}}
							</div>
							
							<div class="flex alcenter center" slot="num" slot-scope="num,record">
								{{num}}人
							</div>
							
							<template slot="action" slot-scope="record">
								<div class="flex center">
									<a-dropdown placement="bottomRight">
										<span class="more-act">
											<i class="iconfont iconmore_gray"></i>
										</span>
										<a-menu slot="overlay">
											  <a-menu-item>
												<a class="menu-act" href="javascript:;" @click="lookGroupMemberAct(record)">
													<i class="iconfont ft14 iconsee"></i>
													<span class="ml10">查看团员</span>
												</a>
											  </a-menu-item>
											  <a-menu-item v-if="record.status==1">
												<a class="menu-act" href="javascript:;" @click="toGroupAct(record)">
													<i class="iconfont ft14 iconedit"></i>
													<span class="ml10">设为成团</span>
												</a>
											  </a-menu-item>
										</a-menu>
									  </a-dropdown>
								</div>
							</template>
						</a-table>
					</div>
				</div>
			
				<div v-if="lookGroupMemberVisible">
					<look-group-member :pin_tuan_group_id="pin_tuan_group_id" :visible="lookGroupMemberVisible" @cancel="cancelLookGroupMember"></look-group-member>
				</div>
				
				<div v-if="toGroupVisible">
					<to-group :pin_tuan_group_id="pin_tuan_group_id" :visible="toGroupVisible" @cancel="cancelToGroup" @ok="okToGroup"></to-group>
				</div>
			</div>
		</div>
	</div>
				
</template>

<script>
	import {
		listMixin
	} from '../../../../common/mixin/list.js';
	import lookGroupMember from './manage/modal/groupmember.vue';
	import toGroup from './manage/modal/toGroup.vue';
	export default {
		mixins: [listMixin],
		components:{
			lookGroupMember,
			toGroup,
		},
		data() {
			return {
				loading: false,
				lookGroupMemberVisible:false,
				toGroupVisible:false,
				pin_tuan_group_id:0,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					status:1
				},
				columns: [
					{title: '商品编号',key: 'goods_id',align: 'center',scopedSlots: {customRender: 'goods_id'}},
					{title: '拼团商品',dataIndex: 'pin_tuan_goods',align: 'center',width:400,scopedSlots: {customRender: 'pin_tuan_goods'}},
					{title: '成团人数',dataIndex: 'group_size',align: 'center',scopedSlots: {customRender: 'group_size'}},
					{title: '团长',dataIndex: 'chief',align: 'center',scopedSlots: {customRender: 'chief'}},
					{title: '团员',dataIndex: 'num',align: 'center',scopedSlots: {customRender: 'num'}},
					{title: '创建时间',dataIndex: 'add_time_format',align: 'center',ellipsis: true},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}},
				],
				datas: [],
			}
		},
		methods: {
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getGroupList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					status:this.search.status,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			changeStatus(){
				this.pagination.current=1;
				this.getLists();
			},
			
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			
			lookGroupMemberAct(record){
				this.pin_tuan_group_id=record.pin_tuan_group_id;
				this.lookGroupMemberVisible=true;
			},
			cancelLookGroupMember(){
				this.lookGroupMemberVisible=false;
			},
			
			toGroupAct(record){
				this.pin_tuan_group_id=record.pin_tuan_group_id;
				this.toGroupVisible=true;
			},
			cancelToGroup(){
				this.toGroupVisible=false;
			},
			okToGroup(){
				this.toGroupVisible=false;
			}
			
		}
	}
</script>

<style>
	
	.goods-index-table img{
		width: 80px;
		height: 60px;
	}
	
	.goods-index-cover-img{
		width: 60px;
		height: 60px;
		position: relative;
	}
	.goods-index-cover-img img{
		width: 60px;
		height: 60px;
	}
	.goods-index-cover-img .tag{
		position: absolute;
		top:0px;
		left: 0px;
		padding: 0px 4px;
		background: #FF6600;
		
		font-size: 12px;
		font-weight: 500;
		color: #FFFFFF;
	}
	
	.manage-goods-item.tag{
		padding: 1px 4px;
		background: rgba(71, 114, 255, 0.1);
		border-radius: 2px;
		
		font-size: 12px;
		font-weight: 500;
		color: #4772FF;
	}
	
	.pin-tuan-goods-num-box{
		padding: 2px 8px;
		background: #FFFFFF;
		border-radius: 2px;
		border: 1px solid #4772FF;
		
		font-size: 12px;
		font-weight: 500;
		color: #4772FF;
	}
</style>
